import React, { useState } from 'react';
import { Text, Flex, Icon } from '@chakra-ui/react';
import { TopSection, NavButton, ReportsTable } from '@/features/reports_mock';
import { FiBarChart2 } from 'react-icons/fi';
import { BsGrid } from 'react-icons/bs';
import RiskMatrixPage from './RiskMatrixPage';
import EcomindPage from './EcomindPage';

export function ReportsPage() {
  const [selectPage, setSelectPage] = useState(0);
  return selectPage === 0 ? (
    <>
      <TopSection />
      <Flex
        marginTop={20}
        justify="space-between"
        align="center"
        bg="white"
        py={4}
        borderRadius="12px"
      >
        <Text
          px={6}
          pb={4}
          fontWeight="600"
          borderBottomColor="teal.400"
          borderBottomWidth={3}
        >
          Ecomind Demo
        </Text>

        <Flex gap={3} pb={4}>
          <NavButton
            borderColor="blue.600"
            borderWidth={2}
            label="Relatório CEO"
            color="blue.600"
            leftIcon2={<Icon as={FiBarChart2} />}
            onClick={() => setSelectPage(2)}
          />

          {/* <NavButton
            borderColor="gray.600"
            borderWidth={2}
            label="Matriz de Risco"
            color="gray.600"
            leftIcon2={<Icon as={BsGrid} />}
            onClick={() => setSelectPage(1)}
          /> */}
        </Flex>
      </Flex>
      <ReportsTable />
    </>
  ) : selectPage === 1 ? (
    <RiskMatrixPage OnBack={() => setSelectPage(0)} />
  ) : (
    <EcomindPage OnBack={() => setSelectPage(0)} />
  );
}
